import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, CustomSelect, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import SortBy from '../../SortBy';
import {
  CardsWrapper,
  FiltersContainer,
  FixedContainer,
  Legend,
  PaginationWrapper,
  Sorting,
} from './style';
import { formatFilterOpt, getFilterLabel } from '../../../../utils/labels';
import {
  DOCUMENTS_CATEGORIES_GET,
  DOCUMENTS_LIST_GET,
} from '../../../../app/redux/actions/documents';
import CardInnerDocument from './CardInnerDocument';
import Pagination from '../../Pagination';

export const ModalInnerDocumentsId = 'ModalInnerDocuments';

const ModalInnerDocuments = ({
  mediaIsPhone,
  mediaIsTablet,
  isOpen,
  id,
  excluded_ids,
  filters,
  list,
  pager,
  categories,
  getDocumentsList,
  getCategories,
  modalClose,
  saveDocuments,
}) => {
  const scrollableAreaRef = useRef(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [search, setSearch] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [showFilters, setShowFilters] = useState(true);

  useEffect(() => {
    if (isOpen && id === ModalInnerDocumentsId) handleGetDocuments();
    return () => {
      setSelectedFilters({});
      setSelectedDocuments([]);
      setSearch('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, id]);

  useEffect(() => {
    if (categories?.length <= 0) getCategories();
    getDocumentsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShowFilters(!mediaIsPhone);
  }, [mediaIsPhone]);

  const handleGetDocuments = (page) => {
    const formatFilters = { excluded_ids, ...selectedFilters, page };
    if (formatFilters?.subject) {
      formatFilters.single_categories = formatFilters?.subject;
    } else if (formatFilters?.categories) {
      formatFilters.parent_categories = formatFilters?.categories;
    }
    delete formatFilters?.categories;
    delete formatFilters?.subject;
    getDocumentsList(formatFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) {
      handleGetDocuments();
    }
    if (selectedFilters.categories) {
      setSubjects(
        categories.find((c) => c?.id === selectedFilters?.categories)?.children
      );
    } else setSubjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const docSeletedIndex = (doc) => {
    return selectedDocuments.findIndex((d) => d.id === doc?.id);
  };

  const handleOnClick = (doc) => {
    const newDocs = [...selectedDocuments];
    const idIndex = docSeletedIndex(doc);
    if (idIndex < 0) newDocs.push(doc);
    else newDocs.splice(idIndex, 1);
    setSelectedDocuments(newDocs);
  };

  const loadMore = (page) => handleGetDocuments(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Inserisci documenti"
      modalId={ModalInnerDocumentsId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={24}
    >
      <FixedContainer>
        <Text type="h2" mb={mediaIsPhone ? 8 : 24}>
          Archivio SISFOR
        </Text>
        <Text type="b3" mb={mediaIsPhone ? 16 : 32}>
          In questo archivio è possibile visualizzare tutti i documenti presenti
          all’interno della piattaforma SISFOR+.
        </Text>
        <div className="d-flex sb mb-2">
          <CustomInput
            size={mediaIsPhone ? 's' : 'l'}
            placeholder="Cosa vuoi cercare?..."
            isSearch
            icon="search-sm"
            isClearable
            onChange={(v) => setSearch(v)}
            onClickIcon={() =>
              setSelectedFilters({
                ...selectedFilters,
                search_text: search,
              })
            }
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                setSelectedFilters({
                  ...selectedFilters,
                  search_text: search,
                });
              }
            }}
            value={search}
          />
          {mediaIsPhone && (
            <CTA
              type="secondary"
              btnText={showFilters ? 'Nascondi' : 'Filtri'}
              onClick={() => setShowFilters(!showFilters)}
            />
          )}
        </div>
        {showFilters && (
          <FiltersContainer>
            <CustomSelect
              size={mediaIsPhone ? 'full' : 's'}
              placeholder="Area tematica"
              options={categories}
              onChange={(v) => {
                setSelectedFilters({
                  ...selectedFilters,
                  subject: undefined,
                  categories: v?.id,
                });
              }}
              isClearable
            />
            {subjects?.length > 0 && (
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Materia"
                options={subjects}
                selected={
                  subjects?.find((s) => s?.id === selectedFilters?.subject) ||
                  null
                }
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    subject: v?.id,
                  })
                }
              />
            )}
            {(Object.keys(filters) || []).map((key, i) => (
              <CustomSelect
                key={`filter-${i}`}
                size={mediaIsPhone ? 'full' : 's'}
                placeholder={getFilterLabel(key)}
                options={filters[key].map((opt) => formatFilterOpt(opt))}
                onChange={(value) => handleOnChange({ key, value })}
                isClearable
              />
            ))}
            {mediaIsPhone && (
              <SortBy
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    sort_by: v?.value,
                  })
                }
              />
            )}
          </FiltersContainer>
        )}
        {mediaIsPhone ? (
          <Text type="b3" mb={24}>
            {list?.length || 0} documenti disponibili
          </Text>
        ) : (
          <Sorting className="d-flex sb g-24">
            <Text type="b3">{list?.length || 0} documenti disponibili</Text>
            <SortBy
              onChange={(v) =>
                setSelectedFilters({
                  ...selectedFilters,
                  sort_by: v?.value,
                })
              }
            />
          </Sorting>
        )}
      </FixedContainer>
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ minWidth: 'min(1020px, 75vw)' }}
        preserveShadows
      >
        {!(mediaIsPhone || mediaIsTablet) && (
          <Legend className="uppercase">
            <Text type="h3.5">Formato</Text>
            <Text type="h3.5">Titolo</Text>
            <Text type="h3.5">Tipologia</Text>
            <Text type="h3.5">Data</Text>
            <Text type="h3.5">Dimensioni</Text>
          </Legend>
        )}
        <CardsWrapper>
          {list?.length > 0 ? (
            list.map((item, index) => (
              <CardInnerDocument
                key={`doc-${index}`}
                item={item}
                className={docSeletedIndex(item) >= 0 ? 'active' : ''}
              >
                <CTA
                  type="tertiary"
                  btnText={docSeletedIndex(item) >= 0 ? 'Annulla' : 'Seleziona'}
                  onClick={() => handleOnClick(item)}
                  bottomRight={mediaIsPhone || mediaIsTablet}
                />
              </CardInnerDocument>
            ))
          ) : (
            <NoResult />
          )}
        </CardsWrapper>
        <PaginationWrapper>
          <Pagination
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        </PaginationWrapper>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Inserisci"
          fullsize={mediaIsPhone}
          disabled={selectedDocuments?.length <= 0}
          onClick={() => {
            saveDocuments(selectedDocuments);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalInnerDocuments.propTypes = {
  excluded_ids: PropTypes.array,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  filters: PropTypes.object,
  list: PropTypes.array,
  pager: PropTypes.object,
  categories: PropTypes.array,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getDocumentsList: PropTypes.func,
  getCategories: PropTypes.func,
  saveDocuments: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { isOpen, id } = state.app.modal;
      const { filters, list, pager, categories } = state.documents;
      return { isOpen, id, filters, list, pager, categories };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCategories: () =>
        dispatch({ type: DOCUMENTS_CATEGORIES_GET._REQUEST }),
      getDocumentsList: (filters) =>
        dispatch({ type: DOCUMENTS_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalInnerDocuments);
